import Button from '@/components/Button';
import type { NotFoundPage } from '@edwin-group/cj-graphql/generated/graphql';
import { fetchNotFoundPage } from '@/services/global/global';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotfoundPage() {
  const [notFoundPage, setNotFoundPage] = useState<NotFoundPage | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const { notFound, error } = await fetchNotFoundPage();
      if (error) {
        return;
      }
      setNotFoundPage(notFound);
    })();
  }, []);

  if (!notFoundPage) return null;

  return (
    <div className="flex min-h-[44rem] items-center justify-center">
      <div className="flex flex-col items-center gap-8">
        <img src={notFoundPage?.image.data?.attributes?.url} className=" w-[430px]" alt="404" />
        <div className=" flex flex-col items-center gap-4">
          <h1 className=" text-sh-md font-bold">{notFoundPage?.title}</h1>
          <p className=" text-sh-sm ">{notFoundPage?.description}</p>
        </div>
        <Button theme="solid" onClick={() => navigate('/login')}>
          {notFoundPage?.cta}
        </Button>
      </div>
    </div>
  );
}
